import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function TaskPrint() {
  const { id } = useParams();
  const { masking } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/tasks/${id}`, { params: { mask: masking } }).then((r) => {
      setData(r.data);
      setTimeout(() => window.print(), 600);
    });
  }, [id, masking]);

  if (!data) return <div style={{ padding: 40, fontFamily: "Arial" }}>Preparing print view…</div>;
  const t = data.task;
  const row = (label, value) => (
    <tr>
      <td style={{ padding: "6px 10px", color: "#64748b", border: "1px solid #e2e8f0", width: 200 }}>{label}</td>
      <td style={{ padding: "6px 10px", color: "#0f172a", border: "1px solid #e2e8f0", fontWeight: 600 }}>{value || "—"}</td>
    </tr>
  );

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 32, fontFamily: "Arial, sans-serif", color: "#0f172a" }} data-testid="task-print">
      <div style={{ fontSize: 11, letterSpacing: 1, textTransform: "uppercase", color: "#94a3b8" }}>HTSS Ops · Demonstration</div>
      <h1 style={{ margin: "4px 0 2px", fontSize: 22 }}>{t.legacy_id}: {t.title}</h1>
      <div style={{ color: "#64748b", fontSize: 13, marginBottom: 18 }}>
        {t.venue_name}{t.venue_address ? `, ${t.venue_address}` : ""}
      </div>

      <h2 style={{ fontSize: 15, color: "#4F46E5", margin: "18px 0 6px" }}>Job Summary</h2>
      <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13 }}>
        <tbody>
          {row("End User", data.end_user?.full_name || t.public_contact)}
          {row("Email", data.end_user?.email)}
          {row("Telephone", data.end_user?.telephone || data.end_user?.mobile)}
          {row("Job Status", t.status)}
          {row("Shop / Dept Status", t.department_status)}
          {row("Job Type", t.task_type)}
          {row("Depot", t.depot)}
          {row("Department", t.department)}
          {row("Work Instructions", t.work_instructions)}
          {row("Payment Status", t.final_payment_date ? "Fully Paid" : t.deposit_date ? "Deposit Paid" : "Awaiting Deposit")}
          {row("Deposit Date", t.deposit_date)}
          {row("Final Payment Date", t.final_payment_date)}
        </tbody>
      </table>

      <h2 style={{ fontSize: 15, color: "#4F46E5", margin: "18px 0 6px" }}>Alerts</h2>
      <ul style={{ fontSize: 13 }}>
        {data.alerts.length === 0 && <li>No alerts</li>}
        {data.alerts.map((a) => <li key={a.key}><strong>{a.title}</strong> — {a.detail}</li>)}
      </ul>

      <h2 style={{ fontSize: 15, color: "#4F46E5", margin: "18px 0 6px" }}>Timeline (reconstructed from import data)</h2>
      <ul style={{ fontSize: 13 }}>
        {data.timeline.map((e, i) => <li key={i}><strong>{e.title}</strong> — {e.ts}</li>)}
      </ul>

      <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 24 }}>Demonstration data only. Personal data is masked or excluded per role.</p>
    </div>
  );
}
